// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');

// @ helpers
const { formatText, getFinalTitle } = require('core/i18n').i18n;

// @ commons
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');

// @ components
const MortgageRequestErrorCustom = require('components/mortgageRequest/mortgageRequestErrorCustom/mortgageRequestErrorCustom');

// @ constants
const { COMMONS: { TASACION_PHONE } } = require('constants/mortgageRequestHolderData');

const MortgagePropertyValueErrorView = props => {
    const { immGlobalPosition } = props;
    const isClientWithoutAccounts = immGlobalPosition.get("isClientWithoutAccounts");
    const mappingBreadcrumb = [
        {
            text: formatText('navbar-loans'),
            url: '/myprofile/loans-mortgages'
        },
        {
            text: formatText('mortgageRequestPresentation-title'),
            url: '/myprofile/mortgage/panel'
        },
        {
            text: formatText('mortgagePropertyValue-breadCrumbText'),
            url: ''
        }
    ].filter((config, index) => (isClientWithoutAccounts && index !== 0) || !isClientWithoutAccounts);

    return (
        <div className="mortgage-property-value-error-view">
            <div className="container-fluid">
                <div className="row">
                    <OKCover size="medium" section="loansmortgages" customClass="col-xs-12">
                        <OKHeaderSubPage
                            breadcrumbConfig={mappingBreadcrumb}
                            finalTitle={getFinalTitle('mortgagePropertyValue-title')}
                        />
                    </OKCover>
                </div>
            </div>
            <div className="grid-view__body">
                <div className="container-fluid">
                    <div className="row grid-view--content-position-negative">
                        <MortgageRequestErrorCustom
                            columns={8}
                            columnsOffset={2}
                            errorTitle={formatText('mortgagePropertyValueError-errorTitle')}
                            goBackButtonLabel={formatText('mortgagePropertyValueError-goBackLabel')}
                            goBackButtonLink={'/myprofile/mortgage/panel'}
                        >
                            <div className="mortgage-request-property-value-error__text">
                                <p>{formatText('mortgagePropertyValueError-simpleNoteError', [TASACION_PHONE])}</p>
                            </div>
                        </MortgageRequestErrorCustom>
                    </div>
                </div>
            </div>
        </div>
    );
};

MortgagePropertyValueErrorView.propTypes = {
    immGlobalPosition: PropTypes.object.isRequired
}

module.exports = connect(
    state => ({
        immGlobalPosition: state.globalPosition,
    }), null
)(MortgagePropertyValueErrorView);
